import DIApi from './_diApi';

class LocalBudgetItemAPI extends DIApi {
  controllerName = 'LocalBudgetItems';
}

export default new LocalBudgetItemAPI();
